import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  addButton: {
    color: theme.palette.common.blue400,
  },
  row: {
    marginBottom: theme.spacing(1),

    '&:last-child': {
      marginBottom: 0,
    },
  },
  addDefaultDocumentsSection: {
    marginBottom: theme.spacing(4),
  },
  marginBottom2: {
    marginBottom: theme.spacing(2),
  },
  // The Settings card's offset for its switches, which cancels the switch's
  // own negative margin so the track lines up with the text above it.
  sendDocumentsOnLanding: {
    marginTop: theme.spacing(4),
    marginLeft: '11px',
  },
  errorsAlert: {
    marginBottom: theme.spacing(3),
    '& > div': {
      margin: 'initial', // Have icon & text left aligned as per design
    },
  },
}));
